import React from 'react'
import { extensionColors } from '../colors'
import { useTheme } from '@mui/material'

interface Props {
  fill?: string
  textFill?: string
}

/**
 * The OStrom slogan as a svg
 */
const OStromSvg: React.FC<Props> = ({ fill = extensionColors.ostrom.secondary, textFill }) => {
  const theme = useTheme()
  return (
    <svg fill="none" width="100%" height="100%" viewBox="0 0 128 30">
      <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
        <path
          fill={fill}
          d="m12.413 0-1.826 9.119-.035.333c-.019 1.538 1.977 2.83 4.506 2.83H28.16c1.479 0 2.807 1.095 2.807 2.574 0 7.596-5.7 13.887-13.136 14.988l1.698-8.767.035-.333c.018-1.492-1.855-2.371-4.275-2.423L3.69 18.169C1.784 18.144.038 16.763.038 14.856.038 7.521 5.352 1.403 12.413 0Z"
        />
        <path
          fill={textFill || theme.palette.background.header}
          d="M81.659 23.524c-.335.124-.947.296-1.855.306-2.258.048-4.296-1.244-4.286-3.912v-8.676h-2.152V8.946h2.152v-3.52h2.86v3.52h3.013v2.296h-3.013v8.082c0 1.655.832 1.961 1.76 1.961.406 0 .73-.067.932-.11l.045-.008.027-.006.517 2.363Zm-22.844-7.165c0 4.544-2.707 7.576-6.849 7.576-4.141 0-6.848-3.032-6.848-7.576 0-4.572 2.707-7.604 6.848-7.604 4.142 0 6.849 3.032 6.849 7.604Zm-10.809-.01c0 2.823 1.263 5.185 3.97 5.185 2.688 0 3.95-2.362 3.95-5.184 0-2.812-1.262-5.204-3.95-5.204-2.707 0-3.97 2.392-3.97 5.204Zm18.333 7.586c3.549 0 6.007-1.884 6.007-4.544 0-2.075-1.32-3.357-4.017-3.979l-2.334-.535c-1.617-.383-2.315-.928-2.305-1.923-.01-1.129 1.214-1.932 2.84-1.932 1.78 0 2.602.985 2.937 1.97l2.592-.459c-.593-2.286-2.381-3.778-5.557-3.778-3.319 0-5.672 1.75-5.672 4.352 0 2.085 1.262 3.472 4.017 4.084l2.487.546c1.416.315 2.075.947 2.075 1.865 0 1.138-1.214 2.028-3.089 2.028-1.712 0-2.812-.737-3.156-2.181l-2.765.42c.478 2.602 2.64 4.066 5.94 4.066Zm20.118-.297v-8.972c0-1.922 1.483-3.31 3.51-3.31.594 0 1.263.106 1.492.173V8.793a11.614 11.614 0 0 0-1.214-.067c-1.722 0-3.195.976-3.73 2.554h-.154V8.946h-2.764v14.692h2.86Zm19.041-7.279c0 4.544-2.708 7.576-6.85 7.576-4.141 0-6.848-3.032-6.848-7.576 0-4.572 2.707-7.604 6.849-7.604 4.141 0 6.849 3.032 6.849 7.604Zm-6.84 5.175c-2.707 0-3.97-2.362-3.97-5.184 0-2.812 1.263-5.204 3.97-5.204 2.688 0 3.951 2.392 3.951 5.204 0 2.822-1.263 5.184-3.95 5.184Zm11.934-6.954v9.058h-2.86V8.946h2.745v2.392h.182c.612-1.617 2.057-2.583 3.998-2.583 1.961 0 3.31.976 3.951 2.582h.153c.708-1.568 2.295-2.582 4.41-2.582 2.659 0 4.534 1.674 4.534 5.031v9.852h-2.861v-9.584c0-1.99-1.243-2.831-2.755-2.831-1.865 0-2.946 1.281-2.946 3.051v9.364h-2.85v-9.766c0-1.597-1.1-2.65-2.688-2.65-1.626 0-3.013 1.378-3.013 3.358Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={theme.palette.background.header} d="M.038 0h127.925v30H.038z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default OStromSvg
